import React from 'react';
import Candidate from './Candidate';
import '../stylesheets/caurosel.scss';



class Caurosel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      candidates: [...this.props.data],
      arrowVisibility: {
        opacity: '0'
      },
      animationSlide: {
        transition: '',
        transform: 'translateX(0)'
      }
    };
  };
  handleMouseEnter = () => {
    this.setState({
      arrowVisibility: {
        opacity: '1'
      }
    });
  };
  handleMouseLeave = () => {
    this.setState({
      arrowVisibility: {
        opacity: '0'
      }
    });
  };
  handleClickLeft = () => {
    let cuttingStart = this.state.candidates.slice(0, 5);
    let cuttingRest = this.state.candidates.slice(5);
    this.setState({
      candidates: cuttingRest.concat(cuttingStart),
      animationSlide: {
        transform: 'translateX(0)',
        transition: 'translateX 0.5s ease-in-out'
      }
    });
  };
  handleClickRight = () => {
    let cuttingEnd = this.state.candidates.slice(-5);
    let cuttingRest = this.state.candidates.slice(0, this.state.candidates.length - 5);
    this.setState({
      candidates: cuttingEnd.concat(cuttingRest),
      animationSlide: {
        transform: 'translateX(0)',
        transition: 'translateX 0.5s ease-in-out'
      }
    });
  }
  render() {
    let stateCandidates = this.state.candidates;
    let tenCandidates = stateCandidates.slice(0, 10);
    return (
      <div className='carousel-container'>
        <div
          className='carousel-carousel'
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          <div
            className='arrow-left'
            style={this.state.arrowVisibility}
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
            onClick={this.handleClickLeft}
          >
            <i className='fa-solid fa-angle-left' />
          </div>
          <div className='carousel-view'>
            <ul
              className='carousel'
              style={this.state.animationSlide}
            >
              {tenCandidates.map((element, index) =>
                <Candidate
                  key={index}
                  src={element.image}
                  alt={element.name}
                  name={`${element.firstName} ${element.lastName}`}
                  talent={element.talent}
                  time={element.time}
                  availability={element.availability}
                  location={element.location}
                />
              )}
            </ul>
          </div>
          <div
            className='arrow-right'
            style={this.state.arrowVisibility}
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
            onClick={this.handleClickRight}
          >
            <i className='fa-solid fa-angle-right' />
          </div>
        </div>
      </div>
    )
  }
}

export default Caurosel;